import * as React from 'react';
import './Downloadloader.scss';

export function Downloadloader() {
  return (
    <div className="rp-dwn-loader">
      <div className="dwn-loader" />
    </div>
  );
}
